import { ALLOCATIONS } from "../constants/actionTypes";
import initialState from "./initialState";

export default function allocations(state = initialState.allocations, action) {
  switch (action.type) {
    case ALLOCATIONS.SET_AVAILABLE_ALLOCATIONS:
      return {
        ...state,
        availableAllocations: action.allocations
      };
    case ALLOCATIONS.SET_SELECTED_ALLOCATIONS:
      return {
        ...state,
        selectedAllocations: action.allocations,
        feePeriod: action.feePeriod ?? state.feePeriod
      };
    case ALLOCATIONS.SET_ALLOCATIONS_TO_SUBMIT:
      return {
        ...state,
        allocationsToSubmit: [...state.allocationsToSubmit, ...action.allocations]
      };
    case ALLOCATIONS.SET_REMAINING_AMOUNT_ALLOCATION:
      return {
        ...state,
        allocationsToSubmit: [state.allocationsToSubmit[0], action.allocation]
      };
    case ALLOCATIONS.RESET_ALLOCATIONS_TO_SUBMIT:
      return {
        ...state,
        allocationsToSubmit: []
      };
    case ALLOCATIONS.RESET_ALLOCATIONS:
      return {
        ...state,
        selectedAllocations: [],
        allocationsToSubmit: []
      };

    default:
      return state;
  }
};